import { EMAIL_CONFIRMATION_DATA_PARAM_NAME } from '../const';

export const isEmailConfirmationQuery = (query: string) => {
  const queryParams = new URLSearchParams(query);

  return queryParams.has(EMAIL_CONFIRMATION_DATA_PARAM_NAME);
};
